<template>
    <div>
        <img class="img" :src="templateArgs.data.capa || imgDefault"  @error="placeholder" />
    </div>
</template>

<script>
export default {
    name: 'templateCapa',
    data: () => ({
        templateArgs: {}
    }),
    computed: {
        imgDefault() {
            return require('../assets/sem-imagem.jpg')
        }
    },
    methods: {
        placeholder(e) {
            e.target.src = require('../assets/sem-imagem.jpg')
        },
    },
}
</script>

<style lang="scss" scoped>
.img {
    width: 70px;
    height: 70px;
    object-fit: cover;
}
</style>